export const getCustomerSummary = (shipTo, open) => {
  if (open) {
    return undefined;
  }
  if (!shipTo) {
    return '';
  }
  let text = '';
  if (shipTo.name) {
    text += `${shipTo.name}, `;
  }
  if (shipTo.city) {
    text += `${shipTo.city} `;
  }
  if (shipTo.state) {
    text += `${shipTo.state}`;
  }
  return text;
};
